import lazyLoad from '@utils/lazyLoad'

const wxCard = [
  {
    path: '/members/channel/wxCard',
    exact: true,
    component: lazyLoad(() => import('@views/Members/Channel/WxCard'))
  },
  {
    path: '/members/channel/wxCard/detail/:appId/:id',
    exact: true,
    component: lazyLoad(() => import('@views/Members/Channel/WxCard/detail')),
    meta: {
      applicationCode: '7209ebc7-6536-469a-8a52-dac38de3f941',
      title: '微信会员卡详情'
    }
  },
  {
    path: '/members/channel/wxCard/edit/:appId/:id',
    exact: true,
    component: lazyLoad(() => import('@views/Members/Channel/WxCard/edit')),
    meta: {
      applicationCode: '7209ebc7-6536-469a-8a52-dac38de3f941',
      title: '编辑微信会员卡'
    }
  },
  {
    path: '/members/channel/wxCard/new/:appId',
    exact: true,
    component: lazyLoad(() => import('@views/Members/Channel/WxCard/new')),
    meta: {
      applicationCode: '7209ebc7-6536-469a-8a52-dac38de3f941',
      title: '新建微信会员卡'
    }
  },
  // 渠道二维码分组列表
  {
    path: '/members/channel/qrcodeList',
    exact: true,
    component: lazyLoad(() => import('@views/Members/Channel/Qrcode'))
  },
  // 渠道二维码新建
  {
    path: '/members/channel/new/:type',
    exact: true,
    component: lazyLoad(() => import('@views/Members/Channel/Qrcode/new')),
    meta: {
      applicationCode: '7209ebc7-6536-469a-8a52-dac38de3f941',
      title: '新建'
    }
  },
  // 渠道二维码列表
  {
    path: '/members/channel/codeList/:type/:id',
    exact: true,
    component: lazyLoad(() => import('@views/Members/Channel/Qrcode/codeList')),
    meta: {
      applicationCode: '7209ebc7-6536-469a-8a52-dac38de3f941',
      title: '明细'
    }
  },
  // 渠道二维码详情
  {
    path: '/members/channel/detail/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/Channel/Qrcode/codeDetail')
    )
  }
]

export default wxCard
